import React from 'react';
import { css } from '@emotion/react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import Image from 'gatsby-image/withIEPolyfill';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSyringe, faPills} from '@fortawesome/free-solid-svg-icons';
import urlSlug from 'url-slug';

const ProductBox = styled.li`
    .InyectableBox:hover{
        box-shadow:2px 2px 2px var(--s2color);
    }
    .InyectableBox{
        h3:before{
            background-color:var(--s1color);
        }
    }
    .OralesBox:hover{
        box-shadow:2px 2px 2px var(--s1color);
    }
    .OralesBox{
        h3:before{
            background-color:var(--s2color);
        }
    }
`;

const ProductBox_ = styled(Link)`
    background-color:hsl(210, 15%, 10%);
    display:flex;
    height:12rem;
    position:relative;
    border-radius:3px;
    min-width:230px;
    animation: fadeIn 1s linear;
    margin-bottom:2.4rem;
    
    span{
        position:absolute;
        bottom:.5rem;
        right:.5rem;
        display:flex;
        align-items:flex-end;
    }
`;

const ProductBoxImg = styled(Image)`
    min-width:8rem;
    overflow: visible !important;
    img {
        transform:scale(1.1);
        left:-1rem !important;
    }
`;

const ProductBoxInfo = styled.div`
    position:relative;
    background-color:hsl(210, 15%, 20%);
    margin:.5rem .5rem .5rem 0;
    width:75%;
    clip-path: polygon(0 0, 100% 0, 100% 50%, 65% 100%, 0 100%, 0% 50%);
    padding:.5rem 1rem;
    border-radius:2px;
    display:flex;
    flex-direction:column;
    justify-content:space-between;

    h3{
    position:relative;
    color:var(--txcolor);
    &:before{
        content:'';
        height:3px;
        width:70%;
        
        position: absolute;
        left:0;
        bottom:-.5rem;
        clip-path: polygon(0 0, 0 100%, 100% 50%);
        }
    }
    p{
        font-size:1rem;
        color:var(--txcolor70);
        text-align:left;
    }
`;

export default function BoxProducto ({data}) {


    const {nombre,subtitulo,imagen,categoria} = data;

    return (
        <ProductBox >
        <ProductBox_ to={'/productos-sgl/'+urlSlug(nombre)+'/'} className={categoria.Nombre==='Inyectables' ? 'InyectableBox' : 'OralesBox'}>
            
            <ProductBoxImg
                fluid={imagen.childImageSharp.fluid}
                objectFit='contain'
                alt={`SGL ${nombre}`}
            /> 
            <ProductBoxInfo>
                <h3>{nombre}</h3>
                <p>{subtitulo}</p>
            </ProductBoxInfo>
            <span>
                {categoria.Nombre==='Orales' && <FontAwesomeIcon css={css`color:var(--s2color); font-size:2.8rem;`} icon={faPills}/>}
                {categoria.Nombre==='Inyectables' && <FontAwesomeIcon css={css`color:var(--s1color); font-size:2.8rem;`} icon={faSyringe}/>}
            </span>
        </ProductBox_>
        </ProductBox>
    )
}
